import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BasedataService } from '../shared/basedata.service';

import { ConfigService } from '@docma-mm-core/config/config.service';
import { catchError, map } from 'rxjs/operators';
import {Filter} from "@docma-mm-core/filter/filter";


@Injectable()
export class FilterApiService extends BasedataService {

  private projectUrl: string = '/projects/';
  private configurationFilterUrl: string = '/configuration/filters';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  getAllFilters() : Observable<Filter[]> {
    const endpoint = `${super.getFullUrl(this.configurationFilterUrl)}`;
    let httpParams = new HttpParams();
    httpParams = httpParams.set('$details', '10');

    return this.http
      .get<Filter[]>(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(catchError(e  => this.handleError(e)));
  }

}
